import { useTranslation } from 'react-i18next';
import help from '../../assets/icons/help-circle.svg';

const Information = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full sm:h-1/2 flex flex-col justify-start items-start p-1">
    {/* Requetes expirées */}
    <div className="flex items-center justify-start gap-4">
      <div className="p-3 bg-yellow-trio rounded-xl">
        <img src={help} alt="help" className="w-5 h-5 text-grey-trio" />
      </div>
      <div>
        <h1 className="text-xl font-bold text-gray-700 font-K2D">
          {t("dashboard.helpTitle")}
        </h1>
      </div>
    </div>
    <div className="w-full h-full flex flex-col justify-start items-center mt-1">    
        <p className="text-sm sm:text-md text-gray-600">
            {t("dashboard.helpText")} <br />
        </p>
        <a
            href="mailto:dev@trionode.com"
            className="font-bold text-center w-full underline cursor-pointer"
            >
            dev@trionode.mc
        </a>
    </div>
  </div>
  )
}

export default Information;